"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _Alert = _interopRequireDefault(require("../Alert"));

var _CloseIcon = _interopRequireDefault(require("./CloseIcon"));

var _index = require("./index.styles");

var _excluded = ["mapKey", "removeToast", "children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var transitionInSpeed = 150;
var transitionOutSpeed = 100;
var removeDelay = 100;
var lifeTime = 5000;

var ToastAlert = function ToastAlert(_ref) {
  var mapKey = _ref.mapKey,
      removeToast = _ref.removeToast,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      transitionState = _useState2[0],
      setTransitionState = _useState2[1];

  var refTimer = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      timerStart = _useState4[0],
      setTimerStart = _useState4[1];

  var _useState5 = (0, _react.useState)(lifeTime),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      timeRemaining = _useState6[0],
      setTimeRemaining = _useState6[1];

  var dismiss = function dismiss() {
    setTransitionState('hide');
    pauseTimer();
    setTimeout(function () {
      return removeToast(mapKey);
    }, transitionOutSpeed + removeDelay);
  };

  var pauseTimer = function pauseTimer() {
    setTimeRemaining(timeRemaining - (new Date() - timerStart));
    clearTimeout(refTimer.current);
  };

  var startTimer = function startTimer() {
    setTimerStart(new Date());
    refTimer.current = setTimeout(dismiss, timeRemaining + transitionOutSpeed);
  };

  (0, _react.useEffect)(function () {
    setTransitionState('show');
    startTimer();
    return function () {
      return pauseTimer();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": transitionState === 'show',
    timeout: transitionInSpeed,
    classNames: "show"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": transitionState === 'hide',
    timeout: transitionOutSpeed,
    classNames: "hide"
  }, /*#__PURE__*/_react["default"].createElement(_index.AlertWrapper, {
    transitionInSpeed: transitionInSpeed,
    transitionOutSpeed: transitionOutSpeed,
    onMouseEnter: pauseTimer,
    onMouseLeave: startTimer
  }, /*#__PURE__*/_react["default"].createElement(_index.CloseButton, {
    onClick: dismiss,
    role: "button"
  }, /*#__PURE__*/_react["default"].createElement(_CloseIcon["default"], {
    size: 20
  })), /*#__PURE__*/_react["default"].createElement(_Alert["default"], props, children))));
};

ToastAlert.propTypes = {
  mapKey: _propTypes.string.isRequired,
  removeToast: _propTypes.func.isRequired,
  children: _propTypes.node,
  variant: (0, _propTypes.oneOf)(['info', 'warning', 'success', 'error'])
};
ToastAlert.defaultProps = {
  variant: 'info'
};
var _default = ToastAlert;
exports["default"] = _default;